import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { boot } from 'quasar/wrappers';
import { markRaw } from 'vue';
import { Router } from 'vue-router';
import VueRouter from '../router';
//@ts-ignore
import L from 'leaflet'
import VueDragscroll from 'vue-dragscroll'
import DialogContainer from "src/components/form/containers/DialogContainer.vue";
import * as Sentry from "@sentry/vue";

/*
 * When adding new properties to stores, you should also
 * extend the `PiniaCustomProperties` interface.
 * @see https://pinia.vuejs.org/core-concepts/plugins.html#typing-new-store-properties
 */
declare module 'pinia' {
  export interface PiniaCustomProperties {
     router: Router;
  }
}

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Store instance.
 */


export default boot(({ app }) => {
  let pinia = createPinia();
  pinia.use(piniaPluginPersistedstate);

  pinia.use(({ store }) => {
    store.router = markRaw(VueRouter)
  })

  app.use(pinia);

  app.use(VueDragscroll);

  app.component("DialogContainer", DialogContainer);

  app.config.globalProperties.L = L

  Sentry.init({
    app,
    dsn: "https://60d086c03166e7fb4bba380656c207c7@o336652.ingest.sentry.io/4506575030583296",
    integrations: [
      new Sentry.BrowserTracing({
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [
          "localhost",
          /^https:\/\/dealer\.carfinance247\.co\.uk/,
          /^https:\/\/white-meadow-05081ef03\.2\.azurestaticapps\.net/,
        ],
      }),
      new Sentry.Replay({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
});

